import LocalStorage from '../localstorage'

const localStorage = new LocalStorage();

function savePlayers(players, autoSave, saveGameName) {
    localStorage.savePlayers(players)
    if (autoSave) {
      const savedGames = localStorage.loadSavedGames();
  
      let gameToUpdate = savedGames.find(sg => sg.name === saveGameName)
      gameToUpdate.players = players
      localStorage.saveGame(gameToUpdate)
    }
}  

const addPlayer = (state, player) => {
    state.players.push(player)
    savePlayers(state.players, state.saveSettings.autoSave, state.saveSettings.saveName)
}

const removePlayer = (state, player) => {
    const remainingPlayers = state.players.filter(p => p.name != player.name)
    state.players = remainingPlayers
    savePlayers(state.players, state.saveSettings.autoSave, state.saveSettings.saveName)
}

const updatePlayer = (state, player) => { 
    const foundIndex = state.players.findIndex(p => p.name == player.name)
    state.players[foundIndex] = player
    savePlayers(state.players, state.saveSettings.autoSave, state.saveSettings.saveName)
}

const finishRound = (state) => {
    let playerAmount = state.players.length -1

    if (state.kartengeber == playerAmount) {
        state.kartengeber = 0
    } else {
        state.kartengeber++
    }

    localStorage.saveKartenGeber(state.kartengeber)
}

const gameLoaded = (state, payload) => {
    state.kartengeber = payload.kartengeber
    state.gameStarted = payload.gameStarted
}
const gameFinished = (state) => {
    state.kartengeber = 0
    state.gameStarted = false
    localStorage.saveKartenGeber(0)
    localStorage.saveGameStarted(false)
}

const startGame = (state) => {
    state.gameStarted = true
    localStorage.saveGameStarted(true)
    localStorage.saveKartenGeber(state.kartengeber)
}

const toggleEditMode = (state) => {
    state.editMode = !state.editMode;
}

const enableAutoSave = (state, gamename) => {
    state.saveSettings.autoSave = true
    state.saveSettings.saveName = gamename
    localStorage.saveAutoSave(state.saveSettings.autoSave, state.saveSettings.saveName)
}

const autoSaveSettingsLoaded = (state, settings) => {
    if(settings) {
        state.saveSettings = settings
    }
}

export {
    savePlayers,
    addPlayer,
    removePlayer,
    updatePlayer,
    finishRound,
    gameLoaded,
    gameFinished,
    startGame,
    toggleEditMode, 
    enableAutoSave, 
    autoSaveSettingsLoaded
}